import { ConfirmDialogService, FormatDisplay, ToastService, useDataTableBasic, useDialogCrup, useForm } from '@iamsoftware/react-hooks';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { TabPanel, TabView } from 'primereact/tabview';
import { Fragment, useEffect, useState } from 'react';
import { CommonService } from '../../../service/CommonService';
import { AccountInfoService as Service } from './AccountInfoService';

export const AccountInfo = () => {
  const header = "Quản lý tài khoản";
  const [accInfo, setAccInfo] = useState(null)
  const [assetList, setAssetList] = useState(null)
  const [stateGeoId, setStateGeoId] = useState([])
  const [counties, setCounties] = useState([]);
  const [reload, setReload] = useState(true)

  // Form states
  const [partyName, setPartyName] = useState('');
  const [partyTax, setPartyTax] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (reload === true) {
      Service.getInfo().then(data => {
        data.assetList.map(item => {
          item.usedQuantity = item?.originalQuantity - item?.quantityOnHandTotal;
          item.receivedDate = FormatDisplay.date(item.receivedDate, 'YYYY-MM-DD');
          item.activationValidThru = FormatDisplay.date(item.activationValidThru, 'YYYY-MM-DD');
          return item
        })
        setAccInfo(data)
        setAssetList(data.assetList)
      })
      setReload(false);
    }
  }, [reload]);

  useEffect(() => {
    CommonService.getProvinces().then(({ listData }) => {
      setStateGeoId(listData.map(item => {
        return { value: item.toGeoId, label: item.geoName }
      }))
    })
  }, []);
  // Load danh sách quận/huyện theo tỉnh/thành phố
  const { render: renderDataTableBasic } = useDataTableBasic({
    tableHeader: '',
    dataKey: 'assetId',
    columns: [
      { field: 'assetName', header: 'Gói dịch vụ', minWidth: 200 },
      { field: 'receivedDate', header: 'Ngày hiệu lưc', minWidth: 150, dataType: 'date' },
      { field: 'activationValidThru', header: 'Ngày hết hạn', minWidth: 150, dataType: 'date' },
      { field: 'originalQuantity', header: 'Số lượng', minWidth: 100, dataType: 'number' },
      { field: 'usedQuantity', header: 'Đã dùng', minWidth: 100, dataType: 'number' },
      { field: 'quantityOnHandTotal', header: 'Còn lại', minWidth: 100, dataType: 'number' },
    ],
    items: assetList
  })

  const formRepresentative = useForm({
    fields: [
      { field: 'representativeName', header: 'Tên người đại diện', className: 'md:col-6' },
      { field: 'representativeJobTitle', header: 'Chức vụ người đại diện', className: 'md:col-6' }
    ],
    readOnly
  })

  const { render: renderDialogCrup, update, form } = useDialogCrup({
    header: 'thông tin',
    width: '80rem',
    fields: [
      {
        field: 'pseudoId', header: 'Mã số thuế', className: 'md:col-3', type: 'custom', body: <Fragment>
          <label>Mã số thuế</label>
          <div className="p-inputgroup flex-1">
            <InputText
              value={partyTax || ''}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 13);
                e.target.value = value;
                setPartyTax(value);
              }}
              onPaste={(e) => {
                e.preventDefault();
                const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                const cleaned = paste.replace(/[^0-9]/g, '').slice(0, 13);
                setPartyTax(cleaned);
              }}
              maxLength={13}
              pattern="[0-9]*"
              inputMode="numeric"
              placeholder="Nhập mã số thuế"
            />
            <span className="p-inputgroup-addon">
              <Button icon="pi pi-search" className="p-button-info" size="small" onClick={() => doGetPartyByTax(partyTax)} />
            </span>
          </div>
        </Fragment>,
      },
      {
        field: 'partyName', header: 'Tên công ty', required: true, className: 'md:col-9',
        type: 'custom',
        body: <Fragment>
          <label>Tên công ty <span className="text-red-500">*</span></label>
          <InputText
            value={partyName}
            onChange={(e) => {
              const value = e.target.value //.replace(/\d/g, ''); // Company name usually can have digits? Khach-hang removed digits. Keeping consistent if user asked "same as customer management".
              // Actually for Company Name (Organization), digits might be allowed? Khach-hang code removes digits for 'partyName' regardless of type?
              // Let's look at khach-hang code:
              //   onChange={(e) => {
              //     const value = e.target.value.replace(/\d/g, '');
              // It effectively removes digits for Party Name. I will follow this rule strictly as requested.
              const noDigits = value.replace(/\d/g, '');
              setPartyName(noDigits);
              if (form) {
                form.setValue({ ...form.getRawValue(), partyName: noDigits });
              }
            }}
            onPaste={(e) => {
              e.preventDefault();
              const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
              const cleaned = paste.replace(/\d/g, '');
              setPartyName(cleaned);
              if (form) {
                form.setValue({ ...form.getRawValue(), partyName: cleaned });
              }
            }}
            placeholder="Nhập tên công ty"
            disabled={readOnly}
          />
        </Fragment>
      },
      { field: 'address1', header: 'Địa chỉ', className: 'md:col-12' },
      {
        field: 'emailAddress',
        header: 'Địa chỉ email',
        className: 'md:col-4',
        type: 'custom',
        body: <Fragment>
          <label>Địa chỉ email</label>
          <InputText
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (form) {
                form.setValue({ ...form.getRawValue(), emailAddress: e.target.value });
              }
            }}
            type="email"
            placeholder="Nhập địa chỉ email"
            disabled={readOnly}
          />
        </Fragment>
      },
      {
        field: 'phoneNumber',
        header: 'Số điện thoại',
        className: 'md:col-4',
        type: 'custom',
        body: <Fragment>
          <label>Số điện thoại</label>
          <InputText
            value={phoneNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
              setPhoneNumber(value);
              if (form) {
                form.setValue({ ...form.getRawValue(), phoneNumber: value });
              }
            }}
            onPaste={(e) => {
              e.preventDefault();
              const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
              const cleaned = paste.replace(/[^0-9]/g, '').slice(0, 10);
              setPhoneNumber(cleaned);
              if (form) {
                form.setValue({ ...form.getRawValue(), phoneNumber: cleaned });
              }
            }}
            maxLength={10}
            type="tel"
            placeholder="Nhập số điện thoại"
            disabled={readOnly}
          />
        </Fragment>
      },
      { field: 'faxNumber', header: 'Số fax', className: 'md:col-4' },
      { field: 'stateProvinceGeoId', header: 'Tỉnh/Thành phố', className: 'md:col-4', type: 'Dropdown', DropdownProps: { options: stateGeoId, filter: true, filterBy: 'label', filterPlaceholder: 'Tìm kiếm tỉnh/thành phố' } },
      { field: 'countyGeoId', header: 'Phường/Xã', className: 'md:col-4', type: 'Dropdown', DropdownProps: { options: counties, filter: true, filterBy: 'label', filterPlaceholder: 'Tìm kiếm phường/xã' } },
      { field: 'bankName', header: 'Tên ngân hàng', className: 'md:col-6' },
      { field: 'accountNumber', header: 'Số tài khoản', className: 'md:col-6' },
      // {field:'representativeName',header:'Tên người đại diên', className:'md:col-4'},
      // {field:'representativeJobTitle',header:'Chức vụ người đại diện', className:'md:col-4'},
      {
        type: 'custom', className: 'md:col-12', body: <Fieldset legend="Người đại diện">
          {formRepresentative.render()}
        </Fieldset>
      }
    ],
    updateItem(id: string, item: any): Promise<any> {
      const validationError = validateFormData(item);
      if (validationError) {
        ToastService.error(validationError);
        return Promise.reject(validationError);
      }
      return Service.updateInfo(inject(item)).then()
    },
    reloadLazyData(data?: any) {
      setReload(true);
    }
  })

  const { stateProvinceGeoId: formProvince } = form.getRawValue() as any;
  const _valueFormRep = formRepresentative.getRawValue();
  const _fromValue = form.getRawValue();

  // Khi đổi tỉnh/thành phố trong form thì load lại danh sách phường/xã
  useEffect(() => {
    if (formProvince) {
      CommonService.getCounties(formProvince).then(({ listData }) => {
        setCounties(listData.map((item: any) => ({
          value: item?.toGeoId,
          label: item?.geoName
        })))
      })
    } else {
      setCounties([])
    }
  }, [formProvince]);

  const validateFormData = (item: any): string | null => {
    // Validate partyName
    if (!partyName || partyName.trim().length === 0) {
      return 'Vui lòng nhập Tên công ty';
    }

    // Validate email
    if (item.emailAddress) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(item.emailAddress)) {
        return 'Địa chỉ email không hợp lệ';
      }
    }

    // Validate phone
    if (phoneNumber) {
      const trimmedContactNumber = phoneNumber?.trim() || '';
      if (trimmedContactNumber.length > 0 && trimmedContactNumber.length !== 10) {
        return 'Số điện thoại phải có đúng 10 số';
      }
    }

    // Validate tax ID
    if (partyTax) {
      const trimmedTaxCode = String(partyTax || '').trim();
      if (trimmedTaxCode.length > 0 && ![10, 12, 13].includes(trimmedTaxCode.length)) {
        return 'Mã số thuế phải có 10, 12 hoặc 13 số';
      }
    }

    return null;
  }

  const inject = (item) => {
    item = { ...item, ..._valueFormRep }
    if (partyTax) item.pseudoId = partyTax; // Map partyTax back to pseudoId or TaxId? Customer uses partyTaxId state and pseudoId field. Here we use pseudoId field as TaxID primarily.
    // In AccountInfo view `accInfo.pseudoId` is tax ID.
    item.partyName = partyName || item.partyName;
    item.phoneNumber = phoneNumber || item.phoneNumber;
    item.emailAddress = email || item.emailAddress;
    return item
  }

  const doGetPartyByTax = (partyTaxId) => {
    if (!partyTaxId || !partyTaxId.trim()) {
      ToastService.error('Vui lòng nhập mã số thuế');
      return;
    }

    const clearData = () => {
      setPartyName('');
      setPhoneNumber('');
      setCounties([]);
      formRepresentative.reset();
      const clearedValue = { ..._fromValue };
      clearedValue.pseudoId = partyTaxId; // Keep tax id
      clearedValue.partyName = '';
      clearedValue.phoneNumber = '';
      clearedValue.emailAddress = '';
      clearedValue.stateProvinceGeoId = null;
      clearedValue.countyGeoId = null;
      clearedValue.address1 = '';
      clearedValue.bankName = '';
      clearedValue.accountNumber = '';
      clearedValue.representativeName = '';
      clearedValue.representativeJobTitle = '';
      form.setValue(clearedValue);
    };

    CommonService.getPartyByTax(partyTaxId).then((response) => {
      const data = response.data;

      // Không return sớm nếu lỗi hoặc không tìm thấy, để logic DKKD bên dưới có cơ hội chạy
      if (data?.errors) {
        console.warn('API nội bộ trả về lỗi:', data.errors);
      }

      const newValue = { ..._fromValue, ...data, ..._valueFormRep };
      // Map contactNumber from search to phoneNumber
      if (data.contactNumber) {
        newValue.phoneNumber = data.contactNumber;
      }

      formRepresentative.setValue(newValue);
      form.setValue(newValue);
      if (data.partyName) setPartyName(data.partyName);
      if (data.contactNumber) setPhoneNumber(data.contactNumber);
      if (data.emailAddress) setEmail(data.emailAddress);

      CommonService.getPartyFromDKKDAutomated(partyTaxId).then((dkkdData) => {
        if (dkkdData && dkkdData.length > 0) {
          const ent = dkkdData[0];
          const finalUpdate = { ...newValue };

          if (ent.Name) {
            finalUpdate.partyName = ent.Name;
            setPartyName(ent.Name);
          }
          if (ent.Legal_First_Name) {
            finalUpdate.representativeName = ent.Legal_First_Name;
          }
          if (ent.Legal_Job_Title) {
            finalUpdate.representativeJobTitle = ent.Legal_Job_Title;
          }
          if (ent.Ho_Address_F) {
            finalUpdate.address1 = ent.Ho_Address_F;
          }

          form.setValue(finalUpdate);
          formRepresentative.setValue(finalUpdate);
        } else if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
          ToastService.error('Không tìm thấy thông tin khách hàng trên hệ thống và DKKD');
        }
      }).catch(err => {
        console.warn('Lỗi tra cứu DKKD:', err);
        if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
          ToastService.error('Không tìm thấy thông tin khách hàng với mã số thuế này');
        }
      });
    }).catch((error) => {
      console.log(error);
      ToastService.error(`Không thể tìm kiếm thông tin với MST : ${partyTaxId}`);
    })
  }

  // Override the update trigger to prepopulate state
  const openUpdate = (data) => {
    setPartyName(data.partyName || '');
    setPhoneNumber(data.phoneNumber || '');
    setPartyTax(data.pseudoId || '');
    setEmail(data.emailAddress || '');
    formRepresentative.setValue(data);
    update(data);
  }


  const topHeader = (
    <div className="flex align-items-center justify-content-between" style={{ padding: '0rem 0 2rem 0' }}>
      <strong style={{ fontSize: '1.2rem' }}>Danh sách chữ ký số: {assetList?.length || 0}</strong>
      <div>
        <Button label="Thêm chữ ký số"></Button>
      </div>
    </div>
  )

  return (
    <div className="card">
      <TabView>
        <TabPanel header="Thông tin tài khoản">
          <div >
            <div style={{ padding: '1rem 2rem 0 2rem' }}>
              <div className="flex align-items-center justify-content-between">
                <h5 style={{ alignContent: 'center', margin: '1rem 0' }}>Thông tin chung</h5>
                <Button icon="pi pi-pencil" size="small" rounded severity="warning" onClick={() => openUpdate(accInfo)}></Button>
              </div>
              <div>
                <table style={{ fontSize: '1rem' }}>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Mã số thuế:</th>
                    <th colSpan={3} style={{ textAlign: 'left', }}>{accInfo?.pseudoId}</th>
                  </tr>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Tên đơn vị:</th>
                    <th colSpan={3} style={{ textAlign: 'left' }}>{accInfo?.partyName}</th>
                  </tr>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Địa chỉ:</th>
                    <th colSpan={3} style={{ textAlign: 'left' }}>
                      {accInfo?.address1}</th>
                  </tr>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Người đại diện:</th>
                    <th style={{ textAlign: 'left', width: '20vw' }}>
                      {accInfo?.representativeName}</th>
                    <th className="flex align-item-start" style={{ width: '8vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Chức vụ:</th>
                    <th style={{ textAlign: 'left', width: '20vw' }}>
                      {accInfo?.representativeJobTitle}</th>
                  </tr>
                  <tr>

                  </tr>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Ngân hàng:</th>
                    <th style={{ textAlign: 'left', width: '20vw' }}>
                      {accInfo?.bankName}</th>
                    <th className="flex align-item-start" style={{ width: '8vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Số tài khoản:</th>
                    <th style={{ textAlign: 'left', width: '20vw' }}>
                      {accInfo?.accountNumber}</th>
                  </tr>
                  <tr>

                  </tr>
                </table>
                <hr style={{ width: '74vw' }} />
              </div>
            </div>
            <div style={{ padding: '0 2rem 0rem 2rem' }}>
              <h5>Thông tin nhận thông báo</h5>
              <div>
                <table style={{ fontSize: '1rem' }}>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Email:</th>
                    <th style={{ textAlign: 'left', }}>
                      {accInfo?.emailAddress}
                    </th>
                  </tr>
                  <tr>
                    <th className="flex align-item-start" style={{ width: '10vw', padding: '8px', textAlign: 'left', fontWeight: 'normal' }}>Điện thoại:</th>
                    <th style={{ textAlign: 'left' }}>
                      {accInfo?.phoneNumber}
                    </th>
                  </tr>
                </table>
                <hr style={{ width: '74vw' }} />
              </div>
            </div>
            <div style={{ padding: '0 2rem 2rem 2rem' }}>
              <h5>Dịch vụ đã mua</h5>
              <div>
                {renderDataTableBasic()}
              </div>
            </div>
          </div>
        </TabPanel>
        //thông tin chứ ký số
        {/*<TabPanel header="Thông tin Chữ ký số">*/}
        {/*  <div className="card">*/}
        {/*    {topHeader}*/}
        {/*    {*/}
        {/*      assetList.map((item,index) =>{*/}
        {/*        const cardHeader = (*/}
        {/*          <div className="flex align-items-center justify-content-between" style={{fontSize:'1rem',padding:'0.5rem 2rem 0.5rem 2rem', background:'aliceblue'}}>*/}
        {/*            <strong>Chữ ký số {index + 1}</strong>*/}
        {/*            <div>*/}
        {/*              <Button className="mr-2" icon="pi pi-history" rounded outlined></Button>*/}
        {/*              <Button icon="pi pi-times" rounded outlined></Button>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        )*/}
        {/*        return (*/}
        {/*          <Card header={cardHeader}>*/}
        {/*            <table style={{fontSize: '1rem'}}>*/}
        {/*              <tr>*/}
        {/*                <th className="flex align-item-start" style={{width: '15vw', padding: '6px', textAlign: 'left', fontWeight: 'normal'}}>Tên chủ thể chứng thư số:</th>*/}
        {/*                <th style={{textAlign: 'left'}}>*/}
        {/*                  CÔNG TY TNHH UTACHI*/}
        {/*                </th>*/}
        {/*              </tr>*/}
        {/*            </table>*/}
        {/*          </Card>*/}
        {/*        )*/}
        {/*      })*/}
        {/*    }*/}
        {/*  </div>*/}
        {/*</TabPanel>*/}
      </TabView>
      {renderDialogCrup()}
    </div>
  )
}